import { useApi } from "../lib/api";
import { SectionHead, DataBadge, ErrorState } from "../components/common";
import TokenTable from "../components/TokenTable";
import usePageMeta from "../lib/usePageMeta";

export default function Stocks() {
  usePageMeta("Stock Tokens", "Real Robinhood tokenized stocks and ETFs on Robinhood Chain with live onchain prices, volume and holders.");
  const { data, loading } = useApi("/stocks");
  return (
    <div className="space-y-3">
      <SectionHead title="Tokenized Stock Terminal" badge={<DataBadge live={data?.live ?? true} />} />
      <p className="text-xs text-[#6B7280] -mt-1 max-w-3xl">
        Official Robinhood tokenized stock and ETF tokens issued on Robinhood Chain. Prices, volume, market caps and holder counts are live onchain data indexed by Blockscout.
      </p>
      {data && !data.live && <ErrorState />}
      <div className="t-card">
        <div className="px-3 py-2 border-b border-[#262626] text-xs text-[#6B7280]" data-testid="stocks-count">{data ? `${data.items.length} tokenized assets` : "Loading…"}</div>
        <TokenTable tokens={data?.items} loading={loading} testId="stocks-table" />
      </div>
    </div>
  );
}
